import React from 'react';
import HeroSectionNoLink from '../components/HeroSectionNoLink';

const HeroModule = () => (
  <HeroSectionNoLink />
);

export default HeroModule;
